import { handleResponseOld, makePost } from './helpers';

/**
 * @category Title API
 * @see submitCodexLots
 */
type PostCodexLotsParams = {
    authToken: string;
    bidderId: number;
    deployment: string;
    itemIds: Array<number>;
};
/**
 * Posts a request with lots to register with codex by given bidderId
 * @function submitCodexLots
 * @category Title API
 * @param {PostCodexLotsParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/title/${bidderId}/lots
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/4nwezlyqk1/resources/8i0cfq/methods/POST
 * @see https://github.com/LIVEauctioneers/titleRegistry-matriculation/tree/master/functions/RegisterTitle-matriculation
 */
const submitCodexLots = ({ authToken, bidderId, deployment, itemIds: lotIds }: PostCodexLotsParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makePost({
            apiPath: 'bidders',
            authToken,
            deployment,
            path: `<TITLE-API>/${bidderId}/lots`,
        });
        request.send({
            lotIds,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};

export default {
    submitCodexLots,
};
